import { baseService } from './baseService'
import Response from '../data/entity/response_entity'
import { STATUS_CODE } from '../data/system_settings'

class BookBorrowService extends baseService {
  async create({ bookId, numOfBorrow, timeOfBorrow }) {
    if (!bookId || !numOfBorrow || !timeOfBorrow) {
      return Response({
        success: false,
        message: {
          content: 'Vui lòng nhập đủ thông tin',
        },
      })
    }

    try {
      const res = await this.post(`borrow/update-info`, { bookId, numOfBorrow, timeOfBorrow })
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: "Tạo thông tin mượn trả thành công",
          },
          data: res.data.data,
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }
  async getAll({ userId, status }) {
    if (!userId) {
      return Response({
        success: false,
        message: {
          content: 'Vui lòng chọn người dùng',
        },
      })
    }

    try {
      const res = await this.get(`borrow/all`, { userId, status })
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else if (res.status === STATUS_CODE.NOT_FOUND) {
        return Response({
          success: false,
          message: {
            content: 'Không tìm thấy thông tin mượn trả',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }

  async getInfo(bookId) {
    if (!bookId) {
      return Response({
        success: false,
        message: {
          content: 'Không tồn tại sách với UUID này',
        },
      })
    }

    try {
      const res = await this.get(`borrow/info`, { bookId })

      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else if (res.status === STATUS_CODE.NOT_FOUND) {
        return Response({
          success: false,
          message: {
            content: 'Đây không phải là sách mượn trả',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }

  async updateInfo({ bookId, numOfBorrow, timeOfBorrow }) {
    if (!bookId || !numOfBorrow || !timeOfBorrow) {
      return Response({
        success: false,
        message: {
          content: 'Vui lòng nhập đủ thông tin',
        },
      })
    }

    try {
      const res = await this.post(`borrow/update-info`, {
        bookId,
        numOfBorrow,
        timeOfBorrow,
      })

      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }
}

const handleError = (error) => {
  if (!error.response) {
    return Response({
      success: false,
      message: {
        content: 'Lỗi không xác định',
      },
    })
  }

  const { status, data } = error.response
  let message = 'Lỗi không xác định'

  switch (status) {
    case STATUS_CODE.NOT_FOUND:
      message = 'Không tìm thấy sách'
      break
    case STATUS_CODE.FORBIDDEN:
      message = 'Không có quyền truy cập'
      break
    case STATUS_CODE.BAD_REQUEST:
      message = data?.status || 'Dữ liệu không hợp lệ'
      break
    case STATUS_CODE.SERVER_ERROR:
      message = 'Lỗi từ phía server'
      break
    default:
      message = data?.status || 'Lỗi không xác định'
  }

  return Response({
    success: false,
    message: {
      content: message,
    },
  })
}

export const bookBorrowService = new BookBorrowService() 